<template>
  <div class="page">
    <div class="page-container">
      <template v-if="!submited">
        <project-page-header ref="pageHeader" :id="projectId"></project-page-header>
        <div class="page-title">项目预算表</div>
        <a-spin :spinning="loading">
          <div class="panel-body">
            <div class="w1000 v-mt-md">
              <a-form-model class="form-sm" ref="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
                <a-form-model-item :colon="false" v-if="budget.checkResult === -1">
                  <span slot="label"></span>
                  <a-alert class="v-mb-sm no-border" type="error">
                    <div slot="message">
                      <div class="font-md text-darkblue flex items-center">
                        <a-icon type="alert" class="v-mr-xs" />
                        提交的项目预算表已被驳回
                      </div>
                      <div class="flex v-mt-xs">
                        <span class="text-right text-grey">审核意见：</span>
                        <span class="col text-red" v-html="$utils.convertToHtml(budget.checkOpinion)"></span>
                      </div>
                    </div>
                  </a-alert>
                </a-form-model-item>
                <a-form-model-item :colon="false">
                  <span slot="label">
                    <i class="required-mark">*</i>
                    预算总金额
                  </span>
                  <div class="input-wrapper">
                    <a-input-number v-model="amount" ref="amount" style="width: 220px" placeholder="预算金额" class="no-handler" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" allow-clear />
                    <span class="input-unit">元</span>
                  </div>
                  <!-- <a-input-number class="no-handler" v-model="amount" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" :min="0" ref="amount" style="width: 200px"/> 元 -->
                </a-form-model-item>
                <a-form-model-item :colon="false">
                  <span slot="label">
                    <i class="required-mark">*</i>
                    项目预算表文件
                  </span>
                  
                  <a-upload-dragger
                    :action="`${baseURL}/file/upload`"
                    :data="{
                      params: JSON.stringify({ projectId, fileBelongId: projectId, fileType: 1, fileSign: 'P01' }),
                    }"
                    :file-list="files"
                    :before-upload="beforeUploadFile"
                    @preview="handlePreviewFile"
                    @change="info => handleUploadChange(info, -1)"
                    accept=".doc, .docx, .xls, .xlsx, .pdf, .ppt, .pptx, .png, .jpg, .jpeg, .gif"
                    class="uploader-md"
                    ref="files"
                  >
                    <p class="ant-upload-drag-icon">
                      <a-icon type="upload" />
                    </p>
                    <p class="ant-upload-text">点击选择或拖拽文件至此区域上传<br/><span class="text-grey">（可以上传多份预算表文件）</span></p>
                  </a-upload-dragger>
                </a-form-model-item>
              </a-form-model>
              <div class="text-center v-mt-lg">
                <a-space>
                  <a-button icon="check" type="indigo" key="draft" @click="handleConfirmSubmit(false)" :loading="saving">保存初稿</a-button>
                  <a-button icon="arrow-right" type="primary" key="submit" @click="handleConfirmSubmit(true)" :loading="saving">提交审核</a-button>
                  <a-button icon="left" type="default" key="backward" @click="$router.go(-1)">返回</a-button>
                </a-space>
              </div>
            </div>
          </div>
        </a-spin>
      </template>
      <template v-else>
        <a-result status="success" title="提交成功" sub-title="您上传的项目预算表已提交审核，请耐心等待审核结果。">
          <template #extra>
            <a-button key="view" type="primary" @click="$router.push(`view?id=${projectId}`)">查看项目</a-button>
            <a-button key="back" @click="$router.go(-1)">返回</a-button>
          </template>
        </a-result>
      </template>
    </div>
  </div>
</template>

<script>
import ProjectPageHeader from './common/page-header'
import { getBudget, saveBudget } from '@/api/project/house'
export default {
  name: 'ProjectBudget',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: undefined,
      submited: false,
      loading: false,
      currentStep: 0,
      saving: false,
      project: {},
      budget: {},
      amount: undefined,
      files: [],
    }
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.loadBudget()
      }
    },
    loadBudget() {
      this.loading = true
      getBudget(this.projectId).then(({ data }) => {
        if (data.success) {
          this.budget = data.result
          let { amount, files } = data.result
          this.amount = amount
          this.files = files.map(file => ({
            ...file,
            uid: file.fileId,
            name: file.fileOriginName,
            fileSign: 'P01',
            status: 'done',
          }))
        }
        this.loading = false
      })
    },
    handleConfirmSubmit(nextStep) {
      this.$message.destroy()
      let { amount } = this
      if (!amount) {
        this.$refs.amount.focus()
        this.$message.warn('请输入预算总金额')
        return
      }
      if (this.files.length === 0 ) {
        this.$message.warn('请上传预算表文件')
        this.$refs.files.$el.classList.add('uploader-empty')
        return
      }
      this.$confirm({
        title: nextStep ? '确认提交项目预算表？' : '确认保存初稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      let { projectId, amount, files } = this
      let params = {
        id: projectId,
        amount: amount,
        fileIds: files.map(d => d.fileId),
        nextStep,
      }
      this.saving = true
      saveBudget(params)
        .then(({ data }) => {
          if (data.success) {
            if (nextStep) {
              this.submited = true
            } else {
              this.$message.success('操作成功')
              this.$router.push(`view/finance?id=${projectId}`)
            }
          } else {
            this.$message.warning(data.msg)
          }
          this.saving = false
        })
        .catch(err => {
          if (err) {
            this.$message.warning(err)
          }
          this.saving = false
        })
    },
    handleUploadChange(info, count) {
      this.files = this.handleUploadFile(info, count)
      this.$refs.files.$el.classList.remove('uploader-empty')
    },
  },
  created() {
    this.init()
  },
}
</script>
